import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { QRCodeSVG } from 'qrcode.react';

import { formatDate, formatMoney, regexPhoneNumber } from 'helpers/helpers'
import { getChequeNote, loadChequeNotes } from 'helpers/chequeNotes'

import logo from 'assets/images/logo.png'
import { useSelector } from 'react-redux';

function ChequeA4({ data = { products: [] }, printChequeRef, show = false }) {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const [products, setProducts] = useState([]);
	const [accessories, setAccessories] = useState([]);
	const [tunikofons, setTunikofons] = useState([]);
	const [profs, setProfs] = useState([]);
	const [totalAmount, setTotalAmount] = useState({
		accessoryTotalQuantity: 0,
	});

	function toNumber(value) {
		return Number(value ?? 0) || 0
	}

	function isPreparedProduct(product) {
		return product?.is_prepared === true || product?.is_prepared === 1 || product?.is_prepared === '1'
	}

	function isMetrReturnProduct(product) {
		const productType = Number(product?.product_type ?? product?.product_type_id)
		return [3, 4, 5].includes(productType) && !isPreparedProduct(product)
	}

	function getReturnQuantity(product) {
		if (isMetrReturnProduct(product)) {
			return toNumber(product?.metr || product?.quantity)
		}

		return toNumber(product?.quantity)
	}

	function getPrintProduct(product) {
		const returnQuantity = getReturnQuantity(product)
		const returnedQuantity = Math.min(toNumber(product.original_returned_quantity), returnQuantity)
		const remainingQuantity = product.remaining_quantity !== undefined
			? toNumber(product.remaining_quantity)
			: Math.max(returnQuantity - returnedQuantity, 0)
		const returnedAmount = product.returned_amount !== undefined
			? toNumber(product.returned_amount)
			: returnedQuantity * toNumber(product.sale_price)
		const totalPrice = product.net_total_price !== undefined
			? toNumber(product.net_total_price)
			: Math.max(toNumber(product.total_price) - returnedAmount, 0)
		const originalSqM = toNumber(product.roll_metr) * toNumber(product.length)
		const sqM = returnQuantity > 0 ? originalSqM * (remainingQuantity / returnQuantity) : 0

		return {
			...product,
			print_quantity: remainingQuantity,
			print_metr: remainingQuantity,
			print_sq_m: sqM,
			print_total_price: totalPrice,
		}
	}

	// A4 eslatma matnini fonda yangilab qo'yamiz (keyingi print uchun localStorage tayyor bo'lsin)
	useEffect(() => {
		loadChequeNotes()
	}, [])

	useEffect(() => {
		const productsData = data?.products || [];

		const type1 = [];
		const accessory = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const tunikofon = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const prof = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};

		const newTotalAmount = {
			productsTotalPrice: 0,
			productsTotalQuantity: 0,
		};

		productsData.forEach(product => {
			const printProduct = getPrintProduct(product);
			if (printProduct.print_quantity <= 0) return;

			if (product.product_type === 1) {
				type1.push(printProduct);
				newTotalAmount.productsTotalQuantity += printProduct.print_quantity;
				newTotalAmount.productsTotalPrice += printProduct.print_total_price;
			} else if (product.product_type === 3) {
				if (product.is_prepared) {
					accessory.preparedChildren.push(printProduct);
					accessory.totalQuantity += printProduct.print_quantity;
				} else {
					accessory.children.push(printProduct);
					accessory.totalQuantity += printProduct.print_metr;
				}
				accessory.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 5) {
				if (product.is_prepared) {
					tunikofon.preparedChildren.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_quantity;
				} else {
					tunikofon.children.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_sq_m;
				}
				tunikofon.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 4) {
				if (product.is_prepared) {
					prof.preparedChildren.push(printProduct);
					prof.totalQuantity += printProduct.print_quantity;
				} else {
					prof.children.push(printProduct);
					prof.totalQuantity += printProduct.print_metr;
				}
				prof.totalPrice += printProduct.print_total_price;
			}
		});

		setProducts(type1);
		setProfs(prof);
		setAccessories(accessory);
		setTunikofons(tunikofon);
		setTotalAmount(newTotalAmount);
	}, [data.products]);

	const printTotalAmount =
		data.net_total_amount !== undefined
			? toNumber(data.net_total_amount)
			: toNumber(profs.totalPrice) +
			toNumber(accessories.totalPrice) +
			toNumber(tunikofons.totalPrice) +
			toNumber(totalAmount.productsTotalPrice)
	const paidAmount = data.net_paid !== undefined ? toNumber(data.net_paid) : toNumber(data.paid)
	const chequeDebt = data.net_cheque_debt !== undefined ? toNumber(data.net_cheque_debt) : toNumber(data.cheque_debt)

	return (
		<div className={`${show ? '' : 'd-none'}`}>
			<div className={`cheque ${show ? 'p-3' : 'a4'}`} ref={printChequeRef}>
				<div className="row mb-2">
					<div className="col-6">
						<div className="d-flex align-items-center">
							<QRCodeSVG value={data.promotion_url} height={90} />

							<div>
								<div className="color-grey">{data.pos_name}</div>
								<div className="color-grey">{data.pos_address}</div>
								<div className="color-grey">{regexPhoneNumber(data.pos_phone)}</div>
							</div>
						</div>
					</div>
					<div className="col-6">
						<div className="text-center logo">
							{data.logo ?
								<img src={`https://backend.tameer.uz/uploads/poses/${data.logo}`} alt={data.logo} />
								:
								<img src={logo} alt="" />
							}
						</div>
					</div>
				</div>

				<div className="row mb-3">
					<div className="col-6">
						{data.id &&
							<h5>{t('order')} № {data.id}</h5>
						}

						{
							<div className="d-between">
								<div>{t('date')}</div>
								<div>{formatDate(data.cheque_opened_at ? data.cheque_opened_at : new Date(), "dd.MM.yyyy HH:mm")}</div>
							</div>
						}
						<div className="d-between">
							<div>{t('client')}</div>
							<div>{data.client_name}</div>
						</div>
						<div className="d-between">
							<div>{t('phone')}</div>
							<div>{regexPhoneNumber(data.client_phone)}</div>
						</div>
						{data.address &&
							<div className="d-between">
								<div>{t('address')}</div>
								<div>{data.address}</div>
							</div>
						}
						{data.note &&
							<div className="d-between">
								<div>{t('note')}</div>
								<div>{data.note}</div>
							</div>
						}
					</div>

					<div className="col-6">
						<div className="d-flex flex-column justify-content-end h-100">
							<div className="d-between">
								<div>{t('cashier')}</div>
								<div>{data.cashier_name}</div>
							</div>
							<div className="d-between">
								<div>{t('phone')}</div>
								<div>{regexPhoneNumber(data.cashier_phone)}</div>
							</div>
							{data.delivery_type_id &&
								<div className="d-between">
									<div>{t('delivery_type')}</div>
									<div>{data.delivery_type_name}</div>
								</div>
							}
							{data.courier_login &&
								<div className="d-between">
									<div>{t('courier')}</div>
									<div>{data.courier_name}</div>
								</div>
							}

							{data.delivery_date &&
								<div className="d-between">
									<div>{t('delivery_date')}</div>
									<div>{formatDate(data.delivery_date, "dd.MM.yyyy HH:mm")}</div>
								</div>
							}
						</div>
					</div>
				</div>
				<div>

					{profs?.children?.length > 0 &&
						<>
							<hr />
							<h5>{t('profiled_sheeting')}</h5>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('size')}</th>
										<th style={{ minWidth: '40px' }} className="text-end td-ellipsis">{t('quantity2')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('metr')}</th>
										<th style={{ minWidth: '70px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '90px' }} className="text-end td-ellipsis">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{profs.children?.map((item, index) => (
										<tr key={index}>
											<td className="py-0 pe-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="pt-0 text-end">{item.element_quantity}</td>
											<td className="py-0 text-end">{item.quantity}</td>
											<td className="py-0 text-end">{formatMoney((item.print_metr), 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td></td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}

					{profs?.preparedChildren?.length > 0 &&
						<>
							<hr />
							<b>{t('prepared_prof')}</b>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '55px' }} className="text-end td-ellipsis">{t('quantity')}</th>
										<th style={{ minWidth: '60px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('total_amount')}</th>
									</tr>
								</thead>
								<tbody>
									{profs.preparedChildren?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="py-0 text-end">{formatMoney(item.print_quantity, 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}
				</div>

				<div>
					{accessories?.children?.length > 0 &&
						<>
							<hr />
							<h5>{t('accessory')}</h5>

							<table className="table table-border mt-2">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('size')}</th>
										<th style={{ minWidth: '40px' }} className="text-end td-ellipsis">{t('quantity2')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('metr')}</th>
										<th style={{ minWidth: '70px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '90px' }} className="text-end td-ellipsis">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{accessories.children?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="pt-0 text-end">{item.element_quantity}</td>
											<td className="py-0 text-end">{item.quantity}</td>
											<td className="py-0 text-end">{formatMoney((item.print_metr), 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td></td>
										<td></td>
										<td className="text-end">{formatMoney(accessories.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(accessories.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}

					{accessories?.preparedChildren?.length > 0 &&
						<>
							<hr />
							<h5>{t('prepared_accessory')}</h5>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '55px' }} className="text-end td-ellipsis">{t('quantity')}</th>
										<th style={{ minWidth: '60px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('total_amount')}</th>
									</tr>
								</thead>
								<tbody>
									{accessories.preparedChildren?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="py-0 text-end">{formatMoney(item.print_quantity, 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td className="text-end">{formatMoney(accessories.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(accessories.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}
				</div>

				<div>
					{tunikofons?.children?.length > 0 &&
						<>
							<hr />
							<h5>{t('tunikofon')}</h5>

							<table className="table table-border mt-2">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('size')}</th>
										<th style={{ minWidth: '40px' }} className="text-end td-ellipsis">{t('quantity2')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('sq_m')}</th>
										<th style={{ minWidth: '70px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '90px' }} className="text-end td-ellipsis">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{tunikofons.children?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0 td-ellipsis">{item.product_name}</td>
											<td className="pt-0 td-ellipsis">{item.element_name}</td>
											<td className="pt-0 text-end">{item.element_quantity}</td>
											<td className="py-0 text-end">{item.quantity}</td>
											<td className="py-0 text-end">{formatMoney((item.print_sq_m), 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td></td>
										<td></td>
										<td className="text-end">{formatMoney(tunikofons.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(tunikofons.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}

					{tunikofons?.preparedChildren?.length > 0 &&
						<>
							<hr />
							<h5>{t('prepared_tunicophone')}</h5>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '55px' }} className="text-end td-ellipsis">{t('quantity')}</th>
										<th style={{ minWidth: '60px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('total_amount')}</th>
									</tr>
								</thead>
								<tbody>
									{tunikofons.preparedChildren?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="py-0 text-end">{formatMoney(item.print_quantity, 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td className="text-end">{formatMoney(tunikofons.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(tunikofons.totalPrice)}</td>
									</tr>
								</tbody>

							</table>
						</>
					}
				</div>

				{products.length > 0 &&
					<div>
						<hr />
						<h5>{t('products')}</h5>

						<table className="table table-border mt-2">
							<thead>
								<tr>
									<th style={{ width: '40%' }}>{t('name2')}</th>
									<th style={{ width: '15%' }} className="text-end">{t('quantity')}</th>
									<th style={{ width: '15%' }} className="text-end">{t('price')}</th>
									<th style={{ width: '20%' }} className="text-end">{t('total_amount')}</th>
								</tr>
							</thead>
							<tbody>
								{products?.map((item, index) => (
									<tr key={index}>
										<td>{item.product_name}</td>
										<td className="text-end">{formatMoney(item.print_quantity, 3)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.print_total_price)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									<td className="text-end">{formatMoney(totalAmount.productsTotalQuantity, 3)}</td>
									<td></td>
									<td className="text-end">{formatMoney(totalAmount.productsTotalPrice)}</td>
								</tr>
							</tbody>
						</table>
					</div>
				}

				<hr />
				<div className="d-flex flex-column align-items-end">
					<div className="d-between gap-2 fz-18">
						<div>{t('to_pay')}:</div>
						<div className="text-end" style={{ width: '140px' }}>
							{formatMoney(printTotalAmount)}
						</div>
					</div>
					{/* Faqat HAQIQIY pul: Накд / Банк / P2P.
					    Насия (3-kategoriya) bu yerda ko'rsatilmaydi — u to'lov emas, QARZ.
					    U pastdagi "Буюртма қарзи" satrida chiqadi. Ilgari ikkalasi ham ko'rinib,
					    bitta chekda ikki xil raqam turardi (Насия 4 700 000 va qarz 3 900 000) — chalkash edi. */}
					{Object.values(
						(data?.payments || [])
							.filter(p => Number(p.amount) > 0 && Number(p.payment_type_category_id) !== 3)
							// Bir xil tur bir necha marta to'langan bo'lsa (Накд 400 000 + Накд 100 000)
							// bitta qatorga yig'iladi: "Накд: 500 000"
							.reduce((acc, p) => {
								const key = p.payment_type_id
								if (!acc[key]) acc[key] = { name: p.name, amount: 0 }
								acc[key].amount += Number(p.amount)
								return acc
							}, {})
					).map((item, index) => (
						<div className="d-between gap-2" key={index}>
							<div>{item.name}:</div>
							<div className="text-end" style={{ width: '140px' }}>
								{formatMoney(item.amount)}
							</div>
						</div>
					))}
					{toNumber(data.total_returned_amount) > 0 &&
						<div className="d-between gap-2">
							<div>{t('return')}:</div>
							<div className="text-end text-danger" style={{ width: '140px' }}>
								- {formatMoney(data.total_returned_amount)}
							</div>
						</div>
					}

					{/* {data.paid > 0 &&
						<div className="d-between fw-600">
							<div>{t('paid')}</div>
							<div>{data.paid ? formatMoney(data.paid) : 0}</div>
						</div>
					}
					{data.change > 0 &&
						<div className="d-between fw-600">
							<div>{t('change')}</div>
							<div>{formatMoney(data.change)}</div>
						</div>
					}
					{data?.payments?.map((item, index) => (
						item.amount > 0 &&
						<div className="d-between" key={index}>
							<div>{item.name}</div>
							<div>{formatMoney(item.amount)}</div>
						</div>
					))}
					<div className="d-between">
						<div>{t('amount_of_debt')}</div>
						<div>{formatMoney(data.client_balance)}</div>
					</div> */}
				</div>

				<div className="devider">
					<div className="d-between gap-2">
						<div>{t('paid')}:</div>
						<div className="text-end" style={{ width: '140px' }}>
							{formatMoney(paidAmount)}
						</div>
					</div>

					<div>
						{/* <div className="d-between gap-2">
							<div>{t('to_pay')}:</div>
							<div className="text-end" style={{ width: '140px' }}>
								{data.total_amount ? formatMoney(data.total_amount) : 0}
							</div>
						</div> */}
						<div className="d-between gap-2">
							<div>{t('order_debt')}</div>
							<div className="text-end" style={{ width: '140px' }}>
								{formatMoney(chequeDebt)}
							</div>
						</div>
					</div>
				</div>

				<div className="d-between">
					<div className="w-50" style={{ whiteSpace: 'pre-line' }}>
						{getChequeNote(reduxAccount.role)}
					</div>

					<div>
						{/* <div className="d-between w-100">
							<div>{t('order_debt')}</div>
							<div className="text-end" style={{ width: '130px' }}>
								{formatMoney(data.cheque_debt)}
							</div>
						</div> */}
						<div className="d-between w-100">
							<div>{t('previous_debt')}</div>
							<div className="text-end" style={{ width: '130px' }}>
								{/* Qarz mijoz balansiga chek YARATILGANDA yoziladi (statusга bog'liq EMAS),
								    shu sabab client_balance shu chekni ALLAQACHON o'z ichiga oladi.
								    Аввалги қарз = joriy balans − shu chek qarzi (aks holda ikkilanadi). */}
								{formatMoney(Math.abs(Number(data.client_balance) + Number(data.cheque_debt ?? 0)))}
							</div>
						</div>
						<div className="d-between w-100">
							<div>{t('total_debt')}</div>
							<div className="text-end" style={{ width: '130px' }}>
								{/* Жами қарз = mijozning JORIY umumiy qarzi (client_balance) — shu chek allaqachon ichida. */}
								{formatMoney(Math.abs(Number(data.client_balance)))}

							</div>
						</div>
					</div>
				</div>

				<div className="d-flex fw-500 mt-4">
					<div className="d-between align-items-end gap-2 w-100">

						<div className="w-100 no-wrap">
							{reduxAccount.role === 'ROLE_WORKSHOP' ?
								t('received_the_order')
								:
								t('formalized_order')
							}:
						</div>

						<div className="signature" />
					</div>

					<div className="d-between align-items-end gap-2 w-50">
						<div className="w-100 no-wrap">{t('signature')}:</div>

						<div className="signature" />
					</div>
				</div>
			</div>
		</div>
	)
}

export default ChequeA4